// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"354":"78cc8cdc","418":"425f120f","668":"24dfd2a7","672":"5fe5a9fd","739":"af7906bc"}[chunkId] + ".js";
};